import Mousetrap from 'mousetrap';
import '../css/tailwind.css'
import '../css/icons.css'
import UIManager from './modules/ui-manager.js'
import { initGrids } from './modules/grids.js';
import ArtworkHandlers from './modules/artwork-handlers.js';

import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export class App {

    init() {

        Mousetrap.bind('ctrl+q', function () {
            window.location.href = '/logout';
        });

        new UIManager().init();

        initGrids();

        this.registerProgressBar();
        //this.randomizeSpectrumColors();
    }

    registerProgressBar() {

        document.querySelectorAll('a').forEach(link => {
            link.addEventListener('click', () => {
                NProgress.start();
            });
        });

        window.addEventListener('load', () => {
            NProgress.done();
        });
    }

    randomizeSpectrumColors() {
        const spectrumDiv = document.querySelector('.spectrum');

        if (!spectrumDiv) {
            return;
        }

        const colors = [
            'from-green-400 to-green-700',
            'from-blue-400 to-blue-700',
            'from-purple-400 to-purple-700',
            'from-yellow-400 to-yellow-700',
            'from-gray-400 to-gray-700',
            'from-orange-400 to-orange-700',
            'from-red-400 to-red-700',
            'from-teal-400 to-teal-700',
            'from-indigo-400 to-indigo-700',
            'from-pink-400 to-pink-700',
            'from-lime-400 to-lime-700',
            'from-emerald-400 to-emerald-700',
            'from-cyan-400 to-cyan-700',
            'from-amber-400 to-amber-700',
            'from-violet-400 to-violet-700',
            'from-rose-400 to-rose-700',
            'from-fuchsia-400 to-fuchsia-700',
            'from-sky-400 to-sky-700',
            'from-blue-500 to-blue-700',
            'from-green-500 to-green-700',
            'from-purple-500 to-purple-700',
            'from-yellow-500 to-yellow-700',
            'from-gray-500 to-gray-700',
            'from-orange-500 to-orange-700',
            'from-red-500 to-red-700',
            'from-teal-500 to-teal-700',
            'from-indigo-500 to-indigo-700',
            'from-pink-500 to-pink-700',
            'from-lime-500 to-lime-700',
            'from-emerald-500 to-emerald-700',
            'from-cyan-500 to-cyan-700',
            'from-amber-500 to-amber-700',
            'from-violet-500 to-violet-700',
            'from-rose-500 to-rose-700',
            'from-fuchsia-500 to-fuchsia-700',
            'from-sky-500 to-sky-700',
            'from-blue-600 to-blue-700',
            'from-green-600 to-green-700',
            'from-purple-600 to-purple-700',
            'from-yellow-600 to-yellow-700',
            'from-gray-600 to-gray-700',
            'from-orange-600 to-orange-700',
            'from-red-600 to-red-700',
            'from-teal-600 to-teal-700',
            'from-indigo-600 to-indigo-700',
            'from-pink-600 to-pink-700',
            'from-lime-600 to-lime-700',
            'from-emerald-600 to-emerald-700',
            'from-cyan-600 to-cyan-700',
            'from-amber-600 to-amber-700',
            'from-violet-600 to-violet-700',
            'from-rose-600 to-rose-700',
            'from-fuchsia-600 to-fuchsia-700',
            'from-sky-600 to-sky-700'
        ];


        setInterval(() => {
            const buttons = spectrumDiv.querySelectorAll('a');
            buttons.forEach(button => {
                const randomColor = colors[Math.floor(Math.random() * colors.length)];
                // Remove existing color classes
                button.classList.forEach(cls => {
                    if (cls.startsWith('from-') || cls.startsWith('to-')) {
                        button.classList.remove(cls);
                    }
                });
                // Add new random color classes
                randomColor.split(' ').forEach(cls => {
                    button.classList.add(cls);
                });
            });
        }, Math.random() * 2000 + 3000); // random interval between 3 to 5 seconds
    }

    async initPageModule(modulePath, itemId) {
        try {
            const module = await import(`./pages/${modulePath}.js`);
            if (module && module.default) {
                const pageModule = new module.default(itemId);
                pageModule.init();
            }
        } catch (error) {
            console.error(`Error loading module '${modulePath}':`, error);
        }
    }

    async loadPageSpecificModules() {

        const path = window.location.pathname;

        let match;
        switch (true) {
            case (match = path.match(/^\/art\/([a-zA-Z0-9-]+)$/)) !== null:
                const artworkIdElement = document.querySelector('#artworkId');
                if (artworkIdElement) {
                    new ArtworkHandlers(match[1]);
                }
                break;
            case (match = path.match(/^\/art\/([a-zA-Z0-9-]+)\/content$/)) !== null:
                await this.initPageModule('edit-content-artwork', match[1]);
                break;
            case (match = path.match(/^\/category\/([a-zA-Z0-9-]+)\/content$/)) !== null:
                await this.initPageModule('edit-content-category', match[1]);
                break;
            case (match = path.match(/^\/page\/([a-zA-Z0-9-]+)$/)) !== null:
                await this.initPageModule('edit-content-page', match[1]);
                break;
            case (match = path.match(/^\/settings\/pricing$/)) !== null:
                await this.initPageModule('settings-pricing');
                break;
            case (match = path.match(/^\/settings\/ai$/)) !== null:
                await this.initPageModule('settings-ai');
                break;
            case (match = path.match(/^\/settings\/stripe/)) !== null:
                await this.initPageModule('settings-stripe');
                break;
        }
    }
}

document.addEventListener('DOMContentLoaded', async (e) => {
    const app = new App();
    app.init();
    await app.loadPageSpecificModules();
});